import React from 'react';
import { BsLink45Deg } from 'react-icons/bs';
import {
  Flex,
  Icon,
  IconButton,
  List,
  ListItem,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

const InsurancePolicyCell = ({ value: policies = [] }) => (
  <Popover isLazy placement="bottom" trigger="hover">
    <PopoverTrigger>
      <Flex justifyContent="center">
        <IconButton
          icon={<Icon as={BsLink45Deg} h={5} w={5} />}
          variant="textPrimary"
        />
      </Flex>
    </PopoverTrigger>
    <PopoverContent>
      <PopoverArrow />
      <PopoverBody maxH="200px" mt={3} mx={2} overflow="auto">
        <List>
          {policies.length
            ? policies.map(p => (
              <ListItem fontSize="sm" key={p.id}>
                {p.type.displayName}
                {' - '}
                {p.number}
              </ListItem>
            ))
            : <ListItem>No linked policies</ListItem>}
        </List>
      </PopoverBody>
    </PopoverContent>
  </Popover>
);

InsurancePolicyCell.propTypes = { value: PropTypes.arrayOf(PropTypes.shape({ number: PropTypes.string })) };

export default InsurancePolicyCell;
